import Modal from '../../Modal'
import {AmlReportModel} from "../../../redux/companyMonitorTypes";
import {Badge} from "react-bootstrap";

interface Props {
    title: string
    amlReport: AmlReportModel | undefined
    onCloseClick?: () => void
    visible: boolean
}

const AmlReportModal = ({
    title,
    amlReport,
    onCloseClick,
    visible
}: Props) => {

    const handleOnClose = () => {
        onCloseClick && onCloseClick()
    }

    return (
        <Modal
            title={title}
            show={visible}
            okButtonTitle='Close'
            hideCancelButton = {true}
            onHide={() => handleOnClose()}
            onOkClick={() => handleOnClose()}
            onCancelClick={() => handleOnClose()}
            size={'xl'}>

            <div style={{display: "flex", flexDirection: "row", padding: 4, gap: 4}}>
                {amlReport?.isSanction && <Badge bg={"danger"}>Sanctioned</Badge>}
                {amlReport?.isPep && <Badge bg={"warning"}>PEP</Badge>}
                {amlReport?.isRca && <Badge bg={"warning"}>RCA</Badge>}
            </div>

          <pre id="json">{ amlReport?.report }</pre>
        </Modal>
    )
}

export default AmlReportModal
